import React from 'react';
import { useLocation } from 'react-router-dom';
import CoarseAggregateTestResults from './otherServices/CoarseAggregate/CoarseAggregateTestResults';
import CementTestingTestResults from './otherServices/CementTesting/CementTestingTestResults';
import FineAggregateTestResults from './otherServices/FineAggregate/FineAggregateTestResults';

const TestResultsRouter = () => {
  const location = useLocation();
  const module = location?.state?.module;

  console.log('TestResultsRouter Module:', module); // Debugging

  if (module === 'cement') {
    return <CementTestingTestResults />;
  }
  
  if (module === 'fineAggregate') {
    return <FineAggregateTestResults />;
  }

  // Default to Coarse Aggregate if no module match
  return <CoarseAggregateTestResults />;
};

export default TestResultsRouter;
